import { SubMenuList } from '../sub-menu-list';

export class SLAsButton extends SubMenuList {
  name = 'slas';
}
